import { inherits as _inherits, createSuper as _createSuper, classCallCheck as _classCallCheck, createClass as _createClass } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import { NavigationBlockPresentation } from './NavigationBlockPresentation.js';

var NavigationBlockWrapper = /*#__PURE__*/function (_React$Component) {
  _inherits(NavigationBlockWrapper, _React$Component);
  var _super = _createSuper(NavigationBlockWrapper);
  function NavigationBlockWrapper(props) {
    var _this;
    _classCallCheck(this, NavigationBlockWrapper);
    _this = _super.call(this, props);
    _this.state = {
      counter: 0,
      openObject: {},
      noAnimation: false
    };
    return _this;
  }
  _createClass(NavigationBlockWrapper, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.setState({
        counter: this.state.counter + 1
      });
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      if (prevProps.value !== this.props.value) {
        // render twice to update indicator
        this.setState({
          openObject: {},
          counter: this.state.counter + 1,
          noAnimation: false
        });
      }
      if (prevState.openObject !== this.state.openObject) {
        // render twice to update indicator
        this.setState({
          counter: this.state.counter + 1,
          noAnimation: true
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$state = this.state,
        openObject = _this$state.openObject,
        noAnimation = _this$state.noAnimation;
      return /*#__PURE__*/React.createElement(NavigationBlockPresentation, Object.assign({}, this.props, {
        activeRef: function activeRef(r) {
          return _this2.activeElement = r;
        },
        activeElement: this.activeElement,
        openObject: openObject,
        onOpenObjectChange: function onOpenObjectChange(newOpenObject) {
          return _this2.setState({
            openObject: newOpenObject
          });
        },
        noAnimation: noAnimation
      }));
    }
  }]);
  return NavigationBlockWrapper;
}(React.Component);
NavigationBlockWrapper.defaultProps = {
  navigationTree: []
};

export { NavigationBlockWrapper };
